export const isObjectEmpty = (obj = {}) => {
  if (obj === null || obj === undefined) return true;
  return Object.keys(obj).length === 0;
};

export function viewportToPixels(value) {
  var parts = value.match(/([0-9\\.]+)(vh|vw)/);
  var q = Number(parts[1]);
  var side =
    window[['innerHeight', 'innerWidth'][['vh', 'vw'].indexOf(parts[2])]];
  return side * (q / 100);
}

export const formatAppliedFilters = (appliedFilters, filters) => {
  // Helper function to get the formatted filter value based on the entry type
  const getFilterValue = (filterKey, targetIds, filterList, key) => {
    const matchingItems = filterList?.filter((item) =>
      targetIds.includes(item[key]),
    );
    return matchingItems?.length > 0
      ? matchingItems
          .map((item) => item?.data || item?.name || item?.merchant_name)
          .join(', ')
      : '';
  };

  return Object.keys(appliedFilters)
    .map((entry) => {
      const filterName = entry
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase());
      const targetIds = appliedFilters[entry] || [];

      // Handle different filter types
      switch (entry) {
        case 'brand':
          return `${filterName} = ${getFilterValue(
            entry,
            targetIds,
            filters?.brand?.all_other_brands,
            'merchant_id',
          )}`;
        case 'category':
          return `${filterName} = ${getFilterValue(
            entry,
            targetIds,
            filters?.category,
            'id',
          )}`;
        case 'offer_type':
          return `${filterName} = ${getFilterValue(
            entry,
            targetIds,
            filters?.offer_type,
            'id',
          )}`;
        case 'offer_value':
          return `${filterName} = ${getFilterValue(
            entry,
            targetIds,
            filters?.offer_value,
            'id',
          )}`;
        case 'reward_offer':
          return `${filterName} = ${getFilterValue(
            entry,
            targetIds,
            filters?.reward_offer,
            'issuer_id',
          )}`;
        case 'platform':
          return `${filterName} = ${getFilterValue(
            entry,
            targetIds,
            filters?.platform,
            'id',
          )}`;
        default:
          return '';
      }
    })
    .filter(Boolean)
    .join(' \n');
};

export const getAppliedFiltersLabel = (appliedFilters) => {
  if (!appliedFilters || Object.keys(appliedFilters).length === 0) return '';
  return Object.keys(appliedFilters)
    .reduce((labels, key) => {
      const formattedLabel = key
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase());
      labels.push(formattedLabel);
      return labels;
    }, [])
    .join(', ');
};

export const formatTime = (seconds = 0) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  let min = minutes > 10 ? minutes : `0${minutes}`;
  return `${min}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};

export const DevLogger = (content) => {
  return location.hostname === 'localhost' ? console.warn(content) : null;
};
